import { useForm } from '@tanstack/react-form'
import { useState } from 'react'
import { UpdatePassword } from './UpdatePassword'
import { FormInput } from '@/components/custom/form-input'
import LoadingButton from '@/components/custom/loading-button'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useAuthStore } from '@/features/auth/store/authStore'
import { useUpdateUserMutation } from '@/features/users/hooks'
import { /* useEmailValidation,*/ useIsMobile } from '@/hooks'
import { NameSchema } from '@/schemas'
import { formatDate } from '@/utils/timeZoneUtils'

export function UserProfile() {
  const user = useAuthStore((state) => state.user)
  const [isEditing, setIsEditing] = useState(false)
  const isMobile = useIsMobile()

  const { mutateAsync: updateUserMutation, isPending } = useUpdateUserMutation(
    () => setIsEditing(false),
  )

  // const emailValidator = useEmailValidation()

  const form = useForm({
    defaultValues: {
      name: user?.name || '',
      email: user?.email || '',
    },
    onSubmit: ({ value }) => {
      if (!user?._id) return
      return updateUserMutation({
        ...user,
        ...value,
      })
    },
  })

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div
        className={`rounded-lg border bg-white p-6 shadow-sm ${isMobile ? 'w-full' : 'w-[50%]'}`}
      >
        <h1 className="text-xl font-semibold mb-4 text-center">User Profile</h1>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            e.stopPropagation()
            form.handleSubmit()
          }}
          className="space-y-3"
        >
          <form.Field
            name="name"
            validators={{
              onBlur: ({ value }) => {
                const result = NameSchema.safeParse(value)
                return result.success
                  ? undefined
                  : result.error.errors[0].message
              },
            }}
            children={(field) => (
              <div className="gap-0">
                <FormInput
                  placeholder="John Doe"
                  value={field.state.value}
                  onChange={(e) => field.handleChange(e.target.value)}
                  onBlur={field.handleBlur}
                  className="pr-10"
                  field={field}
                  label="Name"
                  disabled={!isEditing}
                />
              </div>
            )}
          />
          <form.Field
            name="email"
            validators={
              {
                // onBlurAsync: async ({ value }) => {
                //   return await emailValidator({ value })
                // },
              }
            }
            children={(field) => (
              <div className="gap-0">
                <FormInput
                  type="email"
                  value={field.state.value}
                  onChange={(e) => field.handleChange(e.target.value)}
                  onBlur={field.handleBlur}
                  className="pr-10"
                  field={field}
                  label="Email"
                  disabled={!isEditing}
                />
              </div>
            )}
          />
          <div className="gap-0">
            <Label htmlFor="createdAt" className="mb-1">
              Created At
            </Label>
            <Input
              type="text"
              value={formatDate(
                user?.createdAt ? new Date(user.createdAt) : new Date(),
                'MMMM D, YYYY',
              )}
              className="pr-10"
              name="createdAt"
              disabled
            />
          </div>
          <div className="gap-0">
            <Label htmlFor="updatedAt" className="mb-1">
              Updated At
            </Label>
            <Input
              type="text"
              value={formatDate(
                user?.updatedAt ? new Date(user.updatedAt) : new Date(),
                'MMMM D, YYYY',
              )}
              className="pr-10"
              name="updatedAt"
              disabled
            />
          </div>

          {isEditing && (
            <form.Subscribe
              selector={(state) => [state.canSubmit]}
              children={([canSubmit]) => (
                <div className="mt-4 flex justify-end gap-2">
                  <Button
                    variant="secondary"
                    onClick={() => setIsEditing(false)}
                  >
                    Cancel
                  </Button>
                  <LoadingButton
                    type="submit"
                    isLoading={isPending}
                    disabled={!canSubmit || isPending}
                  >
                    {isPending ? 'Updating...' : 'Update'}
                  </LoadingButton>
                </div>
              )}
            />
          )}
        </form>
        <div className="mt-4 flex justify-between">
          <UpdatePassword />

          {!isEditing && (
            <Button
              variant="secondary"
              size="sm"
              onClick={() => setIsEditing(true)}
            >
              Edit Profile
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export default UserProfile
